import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";
import { onGetAllMerchant, onGetMerchantDetail } from "mocksdata/merchant";

/*Change Get Api here*/
const getAllUsers = async (query) => {
  console.log(query);
  onGetAllMerchant();
  return axiosInstance({
    method: "get",
    url: "/merchants",
    params: query,
  }).then(handleResponse);
};

/*Change Post Api here*/
const activeOrDeactiveAccount = async ({ merchant, type, deActiveReason }) => {
  console.log(type);
  if (type === "deactive") {
    return await axiosInstance
      .post(`/merchants/deactivate-account`, { ...merchant, deActiveReason })
      .then(handleResponse);
  }
  return await axiosInstance.post(`/merchants/activate-account`, merchant).then(handleResponse);
};

const getMerchantDetail = async (id) => {
  onGetMerchantDetail();
  return axiosInstance({
    method: "get",
    url: `/merchants/${id}`,
  }).then(handleResponse);
};

/*Change Put Api here*/
const updateServiceFee = async (data) => {
  return await axiosInstance.post("/merchants/setup-service-fee", data).then(handleResponse);
};

/*Change Get Api here*/
const deleteApi = async (id, data) => {
  return await axiosInstance.delete("/settings/chains", data).then(handleResponse);
};

export { getAllUsers, activeOrDeactiveAccount, updateServiceFee, deleteApi, getMerchantDetail };
